import classNames from 'classnames';
import { ForwardedRef, HTMLAttributes, ReactNode } from 'react';

import styles from '../../styles/themes/mes-quebec.module.css';

interface MesQuebecProps extends HTMLAttributes<HTMLDivElement> {
    className?: string;
    children: ReactNode;
}

function MesQuebecTheme({
    children,
    className = null,
    ref: containerRef = null,
    ...props
}: MesQuebecProps & { ref?: ForwardedRef<HTMLDivElement> | null }) {
    return (
        <div className={classNames([className, styles.container])} ref={containerRef} {...props}>
            {children}
        </div>
    );
}

export default MesQuebecTheme;
